var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("(Controls - rotate: u,i,  move: j,k,l)")]),_c('canvas',{attrs:{"id":"tetris","height":"240","width":"400"}})])}]

export { render, staticRenderFns }